import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { SyntheticEvent, useEffect, useState } from "react";
import { CompanyTypeFilterChip } from "./CompanyTypeFilterChip/CompanyTypeFilterChip";

export const ProductCatalogBrowse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedValue, setSelectedValue] = useState("category");

  useEffect(() => {
    if (location.pathname.includes("/catalog/product/attribute")) {
      setSelectedValue("attribute");
    } else if (location.pathname.includes("/catalog/product/category")) {
      setSelectedValue("category");
    }
  }, [location.pathname]);

  const handleChange = (event: SyntheticEvent, _: boolean) => {
    const { value } = event.target as HTMLInputElement;

    navigate(`/catalog/product/${value}`);
  };

  return (
    <Box height="100%" overflow="hidden" display="flex" flexDirection="column">
      <Box display="flex" p={1} justifyContent="space-between">
        <FormControl>
          <RadioGroup
            id="categories-and-attributes-radio-group"
            row
            name="browse-row-radio-buttons-group"
            value={selectedValue}
          >
            <FormControlLabel
              value="category"
              control={<Radio />}
              onChange={handleChange}
              label="Product Categories"
            />
            <FormControlLabel
              value="attribute"
              control={<Radio />}
              onChange={handleChange}
              label="Product Attributes"
            />
          </RadioGroup>
        </FormControl>

        <CompanyTypeFilterChip />
      </Box>
      <Divider />
      <Box flex={1} minHeight={0}>
        <Outlet />
      </Box>
    </Box>
  );
};
